import { useEffect, useState } from "react";

const testimonials = [
  {
    id: 1,
    name: "أحمد محمد",
    role: "عميل",
    text: "تجربة ممتازة وسرعة في الاستجابة، وفريق محترف في التعامل وتنفيذ الخدمة.",
  },
  {
    id: 2,
    name: "محمد العتيبي",
    role: "مدير منشأة",
    text: "تعامل احترافي وتنظيم ممتاز في عملية الاستلام والتدوير. تجربة نوصي بها.",
  },
  {
    id: 3,
    name: "سارة أحمد",
    role: "عميلة",
    text: "الخدمة كانت سهلة وواضحة من البداية، والتواصل مع الفريق كان ممتازًا.",
  },
];

// شهادات
export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const testimonial = testimonials[current];
  return (
    <>
      <section className="bg-gray-50 py-20 md:py-24 lg:py-28">
        <div className="mx-auto max-w-4xl px-4 text-center sm:px-6">
          {/* Header */}
          <div className="mb-12">
            <span className="mb-3 inline-block text-sm font-semibold text-green-600">
              آراء العملاء
            </span>

            <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">
              ماذا يقول عملاؤنا؟
            </h2>

            <p className="mx-auto mt-5 max-w-2xl leading-8 text-gray-600">
              رضا عملائنا هو أحد أهم مؤشرات نجاحنا، ونحرص دائمًا على تقديم تجربة
              احترافية في كل خطوة.
            </p>
          </div>

          {/* Testimonial */}
          <div className="relative">
            {/* Quote */}
            <div className="mx-auto max-w-3xl">
              <div className="mb-6 text-6xl font-serif leading-none text-green-600/20">
                “
              </div>

              <p
                key={testimonial.id}
                className="text-xl font-medium leading-9 text-gray-800 transition-all duration-500 md:text-2xl md:leading-10"
              >
                {testimonial.text}
              </p>

              {/* Stars */}
              <div className="mt-7 flex justify-center gap-1 text-yellow-500">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star}>★</span>
                ))}
              </div>

              {/* Customer */}
              <div className="mt-6">
                <h3 className="font-bold text-gray-900">{testimonial.name}</h3>

                <p className="mt-1 text-sm text-gray-500">{testimonial.role}</p>
              </div>
            </div>

            {/* Dots */}
            <div className="mt-10 flex justify-center gap-2">
              {testimonials.map((item, index) => (
                <button
                  key={item.id}
                  onClick={() => setCurrent(index)}
                  aria-label={`عرض رأي ${index + 1}`}
                  className={`h-2 rounded-full transition-all duration-300 ${
                    current === index ? "w-8 bg-green-600" : "w-2 bg-gray-300"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
